import { render, staticRenderFns } from "./TkQuery.vue?vue&type=template&id=5c75a8fd&scoped=true&"
import script from "./TkQuery.vue?vue&type=script&lang=js&"
export * from "./TkQuery.vue?vue&type=script&lang=js&"
import style0 from "./TkQuery.vue?vue&type=style&index=0&id=5c75a8fd&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c75a8fd",
  null
  
)

export default component.exports